/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {PropsWithChildren, ReactElement} from 'react';
import Tooltip from './Tooltip';

interface IonTooltipProps {
  caption?: string;
}

/**
 * A re-usable tooltip customized to Ion's styling.
 * 
 * ```typescript
 *  <IonTooltip caption={caption}>
 *    <Button />
 *  </IonTooltip>
 * ```
 */
export const IonTooltip = ({
  caption,
  children
}: PropsWithChildren<IonTooltipProps>) => {
  return (
    <Tooltip arrow title={caption}>
      {children as ReactElement}
    </Tooltip>
  );
};

export default IonTooltip;
